import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { loadPortfolioDetails } from '../../store/actions/portfolioDetails';
import { Box, Typography } from '@mui/material';
import BackButton from '../../components/common/BackButton';
import InvestorsList from '../../components/portfolioDetailsInvestors/InvestorsList';

const PortfolioDetailsInvestors: React.FC = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);

    useEffect(() => {
        if (id === undefined) {
            navigate(-1);
        }
        if (portfolio === undefined || portfolio.id !== id) {
            dispatch(loadPortfolioDetails(id as string));
        }
    }, [dispatch]);
    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1396px"} gap={"27px"}>
            <Box display={"flex"} gap={"12px"} alignItems={"center"} width={"100%"}>
                <BackButton />
                <Typography fontSize={"20px"} fontWeight={"500"} lineHeight={"24.38px"} textAlign={"center"}>{portfolio?.name} {t('PortfolioDetailsInverstorsPageTitle')}</Typography>
            </Box>
            <InvestorsList />
        </Box>
    </Box>;
}

export default PortfolioDetailsInvestors;